export default __webpack_public_path__ + "static/media/folder-add.0c235499.svg";